import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";

const useAutoLogout = (logoutTime = 30 * 60 * 1000) => {
  const {user} = useContext(AuthContext)
  const [timeLeft, setTimeLeft] = useState(logoutTime);

  useEffect(() => {
    let timeout;
    let interval;

    const logoutUser = () => {
  const token = localStorage.getItem("token");

  if (user?.id) {
    fetch(`${API_URL}/api/session/autologout/${user?.id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).catch((error) => {
      console.error("Auto logout API call failed:", error);
    });
  }

  localStorage.removeItem("token");
  localStorage.removeItem("userPermissions");
  localStorage.removeItem("sidebarDropdownStates");
  // 🔥 Trigger logout event across tabs
  localStorage.setItem("logout", Date.now());
  toast.success("Logged out!");
  window.location.href = "/";
};


    const resetTimer = () => {
      clearTimeout(timeout);
      clearInterval(interval);
      setTimeLeft(logoutTime);

      timeout = setTimeout(logoutUser, logoutTime);

      interval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1000) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1000;
        });
      }, 1000);
    };

    window.onload = resetTimer;
    document.onmousemove = resetTimer;
    document.onkeydown = resetTimer;
    document.onclick = resetTimer;
    document.onscroll = resetTimer;

    resetTimer();

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
      document.onmousemove = null;
      document.onkeydown = null;
      document.onclick = null;
      document.onscroll = null;
    };
  }, [logoutTime]);

  return timeLeft;
};

export default useAutoLogout;
